import { mutate } from 'swr';
import { getCacheKey } from 'utils/getCacheKey';

export const mutatePositions = () => {
  const searchedKey = getCacheKey('/positions');
  if (searchedKey) {
    mutate(searchedKey);
  }
};
